import CryptoJS from 'crypto-js';

const WIDGET_DECRYPTION_KEY = 'YEP_WIDGET_2024_SECRET_KEY_V1';

/**
 * Decrypt an AES-encrypted env variable.
 * Uses the same key as Chatbot-Widget-React (crypto-utils.ts).
 */
export function decryptKey(encryptedText: string): string {
  if (!encryptedText) return '';
  try {
    const decryptedBytes = CryptoJS.AES.decrypt(encryptedText, WIDGET_DECRYPTION_KEY);
    const decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);
    return decryptedText || '';
  } catch {
    console.error('[decryptKey] Decryption failed');
    return '';
  }
}

export const encryptPassword = (plaintext: string, secretKey: string): string => {
  try {
    // Convert the secret key to a proper key format
    const key = CryptoJS.enc.Base64.parse(secretKey);

    // Encrypt using AES with ECB mode and PKCS7 padding
    const encrypted = CryptoJS.AES.encrypt(plaintext, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });

    // Return as base64 string
    return encrypted.toString();
  } catch (error) {
    console.error('Encryption failed:', error);
    throw new Error('Failed to encrypt password');
  }
};
